module.exports = __webpack_public_path__ + "static/media/backArrowMobile.95587bfa.svg";